module.exports = __webpack_public_path__ + "img/check-available-active.8ce0593e.svg";